export const getGatewayScoreColorAndDesc = (gatewayScore) => {
  if (gatewayScore <= 5) {
    return { color: "#F443361A", desc: "Weak" };
  } else if (gatewayScore < 6.5) {
    return { color: "#FFCA281A", desc: "Moderate" };
  } else {
    return { color: "#4CAF501A", desc: "Strong" };
  }
};
